__turbopack_context__.v({
  "hidden": "Toast-module-scss-module__L80WJq__hidden",
  "toast": "Toast-module-scss-module__L80WJq__toast",
  "visible": "Toast-module-scss-module__L80WJq__visible",
});
